<form *ngIf="addEditForm && validation" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate()" RestrictFocus >

  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty">

<!--     <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.user_id.nullable}">{{ validation.user_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [style]="{'width':'100%'}" formControlName="user_id" [options]="user_items" [(ngModel)]="selected_user"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.user_id"></app-validation-msg>
      </div>
    </div> -->

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.user_id.nullable}">{{ validation.user_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-autoComplete
        [style]="{'width':'100%'}"
        formControlName="user_id"
        [suggestions]="user_items"
        [(ngModel)]="selected_user"
        (completeMethod)="getFilteredUsers($event)"
        [dropdown]="true"
        field="label">
        </p-autoComplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.user_id"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.division_sales_network_id.nullable}">{{ validation.division_sales_network_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-autoComplete
           [style]="{'width':'100%'}"
           formControlName="division_sales_network_id"
           [suggestions]="division_items"
           [(ngModel)]="selected_store ?null: selected_division "
           (completeMethod)="getFilteredDivisionStores($event)"
           [disabled]=" selected_store || (selected_store && selected_store.value!==-1 && !(selected_division && selected_store) )"
           field="label"
           [dropdown]="true">
        </p-autoComplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.division_sales_network_id"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.store_id.nullable}">{{ validation.store_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
       <p-autoComplete
        [style]="{'width':'100%'}"
        formControlName="store_id"
        [suggestions]="store_items"
        [(ngModel)]="selected_store"
        (completeMethod)="getFilteredStores($event)"
        [dropdown]="true"
        (onClear)="changeStore($event)"
        field="label"
        [disabled]="selected_division && selected_division.value!==-1 && !(selected_division && selected_store)">
        </p-autoComplete>
        <!--  <app-store-autocomplete
        formControlName="store_id"
        ngDefaultControl
        [selectedStore]="selected_store"
        (selectedStoreChange)="changeStore($event)"
        [disabled]="(selected_division && selected_division.value!==-1 && !(selected_division && selected_store) )"
        > 
        </app-store-autocomplete>  -->
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.store_id"></app-validation-msg>
      </div>
    </div>

    <!-- Campo Scope-->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.scope.nullable}">{{ validation.scope.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="scope"
          formControlName="scope"
          [autoWidth]="false"
          >
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.scope"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <!-- Campo Check Scope solo Negozio
      <div class="ui-grid-col-4"><label> {{'division_sales_network.check_only_store' | translate}}</label></div>
      <div class="ui-grid-col-2">
        <p-checkbox
          [binary]="true"
          formControlName="checkOnlyStore"
          [(ngModel)]="selected_checkOnlyStore"
          [disabled]="!selected_store || !selected_store.value" >
        </p-checkbox>
      </div>-->
      <!-- Campo Check Utente Affiliato-->
      <div class="ui-grid-col-4"><label> {{'division_sales_network.affiliatedUser' | translate}}</label></div>
      <div class="ui-grid-col-2">
        <p-checkbox
          [binary]="true"
          formControlName="flg_use_preferred_store"
          [(ngModel)]="flagAffiliatedUser"
          [disabled]="!selected_user || !selected_user.value">
        </p-checkbox>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{editingElement.id ? ('common.edit' | translate) :  ('common.add' | translate) }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/user-store-division/user-store-division-form.component.html